import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.is-array";
import "core-js/modules/es.array.reduce";
import "core-js/modules/es.object.keys";

/*
 * Copyright (c) 2018 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author:
 *
 *Description:
*/
import Immutable from 'immutable';
import CmsRecord from '../../records/CmsRecord';
export var adapter = function adapter(data) {
  var _keys = Object.keys(data);

  try {
    return Immutable.Map(_keys.filter(function (key) {
      return key !== 'viewName';
    }).reduce(function (result, key) {
      // check if the obj is not an array
      if (!Array.isArray(JSON.parse(data[key]))) {
        var parsedJSON = JSON.parse(data[key]);
        result[key] = CmsRecord({
          id: key,
          isFetching: false,
          data: [parsedJSON]
        });
        return result;
      } else if (typeof data[key] === 'string') {
        try {
          var _parsedJSON = JSON.parse(data[key]);

          result[key] = CmsRecord({
            id: key,
            isFetching: false,
            data: _parsedJSON
          });
        } catch (error) {
          console.log('error parsing cms content', error);
        }

        return result;
      } else {
        return result;
      }
    }, {}));
  } catch (error) {
    console.log('error parsing cms content', error);
    return Immutable.Map({});
  }
};